<script setup lang="ts">
import PostMenu from "./PostMenu.vue";
import VAvatar from "./VAvatar.vue";
import { DateTime } from "luxon";
import Post from "../models/post";
import User from "../models/user";
import PostApi from "../api/post";
import { useAuth } from "@/stores/auth";

const authStore = useAuth();
const props = defineProps<{
  post: Post;
}>();

const emit = defineEmits(["delete-post", "edit-post"]);

const showPostMenu = props.post.user.id == authStore.profile.id;

function datetimeString(datetime: string): string {
  return DateTime.fromISO(datetime, { zone: "utc" })
    .toLocal()
    .toLocaleString(DateTime.DATETIME_MED);
}

async function deletePost() {
  await PostApi.delete(props.post.id);
  emit("delete-post");
}

function editPost() {
  emit("edit-post");
}
</script>

<template>
  <div class="post-card">
    <div class="avatar-column mr-1">
      <div class="author mt-1">
        <VAvatar :src="post.user.avatar.thumbnailUrl" :text="post.user.name" />
      </div>
    </div>
    <div class="content-column">
      <div>
        <strong>{{ post.user.name }}</strong>
        <span class="grey--text"> • </span>
        <span class="grey--text">
          {{ datetimeString(post.timestamp) }}
        </span>
      </div>
      <span class="post">{{ post.text }}</span>
    </div>
    <PostMenu
      v-if="showPostMenu"
      @delete-post="deletePost"
      @edit-post="editPost"
    />
  </div>
</template>

<style lang="scss">
.post {
  white-space: pre-line;
}

.post-card {
  display: flex;
  padding: 16px 0;
}

.post-card:not(:last-child) {
  border-bottom: 1px solid #ccc;
}

.avatar-column {
  flex: 0 0 44px;
}

.content-column {
  flex: 1;
}

.post-card-menu > span {
  cursor: pointer;
  user-select: none;
}
</style>
